import { FC, ReactNode, useContext } from 'react';
import { Page } from './AppointmentFilter.styles';
import { useTranslation } from 'react-i18next';
import {
  Stack,
  MenuItem,
  Box,
  LuxSelect,
  LuxDatePicker,
  LuxLink,
} from '@gemini/fe-ds-core';
import { useGetFhirOrganizationLocations } from '@hooks/useGetFhirOrganizationLocations';
import AppointmentsContext from '@context/AppointmentsContext';
import OrganizationLocationContext from '@context/OrganizationLocationContext';

interface AppointmentFilterProps {
  children?: ReactNode;
}

const AppointmentFilter: FC<AppointmentFilterProps> = () => {
  const { t } = useTranslation();
  const appointmentsContext = useContext(AppointmentsContext);
  const organizationLocationContext = useContext(OrganizationLocationContext);
  const { data: organizationLocations, isLoading } =
    useGetFhirOrganizationLocations({ enabled: true });

  return (
    <Page>
      <Stack flexDirection={'row'} width={'100%'} gap={'1rem'}>
        <Box width={227}>
          <LuxSelect
            value={organizationLocationContext.organizationCoreId ?? ''}
            onChange={e => {
              organizationLocationContext.setContext(
                e.target.value as string | null,
                organizationLocations?.organizations?.find(org => org.id === e.target.value)?.alternateId ?? null,
                null,
              );
            }}
            loading={isLoading}
            label={t('examImport.appointment.organization') ?? ''}
            noHelper
          >
            {organizationLocations?.organizations.map(org => (
              <MenuItem key={org.id} value={org.id}>
                {org.name}
              </MenuItem>
            ))}
          </LuxSelect>
        </Box>
        <Box width={227}>
          <LuxSelect
            value={organizationLocationContext.locationCoreId ?? ''}
            onChange={e => {
              organizationLocationContext.setContext(
                organizationLocationContext.organizationCoreId,
                null, //Switching location only, so no need to change active organization
                e.target.value as string | null,
              );
            }}
            loading={isLoading}
            label={t('examImport.appointment.location') ?? ''}
            noHelper
          >
            {organizationLocations?.locations
              .filter(
                loc =>
                  loc.organizationId === organizationLocationContext.organizationCoreId,
              )
              .map(loc => (
                <MenuItem key={loc.id} value={loc.id}>
                  {loc.name}
                </MenuItem>
              ))}
          </LuxSelect>
        </Box>
        <Box width={277}>
          <LuxDatePicker
            label={t('examImport.appointment.date') ?? ''}
            value={appointmentsContext.date}
            onChange={e => {
              appointmentsContext.setFilter(
                e,
              );
            }}
            pickDay
            required
            noHelper
          />
        </Box>
        <Box
          marginLeft={'auto'}
          alignSelf={'flex-end'}
          height={40}
          display={'flex'}
          alignItems={'center'}
        >
          <LuxLink
            href="#"
            iconStart="HelpIcon"
            label={t('examImport.help') ?? ''}
          />
        </Box>
      </Stack>
    </Page>
  );
};

export default AppointmentFilter;
